<template>
  <div class="ins-range">
    <span v-if="label" class="ins-range-lbl">{{ label }}</span>
    <button
      type="button"
      v-for="o in options"
      :key="String(o.v)"
      class="ins-chip ins-range-chip"
      :class="{ 'ins-chip-on': String(value) === String(o.v) }"
      @click="$emit('input', o.v)"
    >{{ o.label }}</button>
  </div>
</template>

<script>
/* Shared trailing-window toggle (6 / 12 / All) for the Insights trend charts. Value-agnostic:
 * a report supplies its own option values (WOI uses '6'|'12'|'all'; MI uses 6|12|999) and maps
 * the emitted value to its own slice logic. v-model via `value` + `input`. */
export default {
  name: "InsRange",
  props: {
    value: { type: [String, Number], default: "all" },
    label: { type: String, default: "Show" },
    options: {
      type: Array,
      default: () => [
        { v: "6", label: "Last 6 mo" },
        { v: "12", label: "Last 12 mo" },
        { v: "all", label: "All" },
      ],
    },
  },
};
</script>

<style scoped>
.ins-range { display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.ins-range-lbl { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: var(--ins-label, #7a828b); }
.ins-range-chip { padding: 4px 10px; }
</style>
